import {
  goToChosenGrave,
  setLinkedGravesRedux,
  setUserUnReadNotifications,
} from '../../redux/actions';
import store from '../../redux/store';
import { setCachedValue } from '../../service/cache';
import { request } from '../../service/request';

// ---------- Fetch Grave -----------------------
const graveFetchCache = new Map();
const GRAVE_FETCH_TTL_MS = 60 * 1000;

export const fetchGraveDetails = async (slug) => {
  if (!slug) return null;
  const now = Date.now();
  const cached = graveFetchCache.get(slug);
  if (cached?.promise) return cached.promise;
  if (cached?.lastFetchedAt && now - cached.lastFetchedAt < GRAVE_FETCH_TTL_MS) {
    return cached.lastResult || null;
  }
  try {
    const fetchPromise = request(`/graves/${slug}`, null, 'get')
      .then((response) => {
        const grave = response.data;
        if (grave) {
          setCachedValue(`grave:${slug}`, grave, 15 * 60 * 1000);
          store.dispatch(goToChosenGrave(grave));
        }
        graveFetchCache.set(slug, { lastFetchedAt: Date.now(), lastResult: grave });
        return grave;
      })
      .catch((error) => {
        console.error('Failed to fetch grave details:', error);
        graveFetchCache.delete(slug);
        throw error;
      })
      .finally(() => {
        const entry = graveFetchCache.get(slug);
        if (entry?.promise) {
          graveFetchCache.set(slug, { ...entry, promise: null });
        }
      });

    graveFetchCache.set(slug, {
      lastFetchedAt: cached?.lastFetchedAt || 0,
      lastResult: cached?.lastResult || null,
      promise: fetchPromise,
    });
    const result = await fetchPromise;
    return result;
  } catch (error) {
    console.error('Failed to fetch grave details:', error);
    return null;
  }
};

export const fetchLinedGraves = async (id) => {
  try {
    const response = await request(`/link_graves?grave_id=${id}`, null, 'get');
    if (response?.data) {
      setCachedValue(`linked-graves:${id}`, response.data, 10 * 60 * 1000);
      store.dispatch(setLinkedGravesRedux(response.data));
    }
  } catch (error) {
    console.error('Failed to fetch grave details:', error);
  }
};

const userNotification = (cable, userId) => {
  if (!isAlreadySubscribed(cable, userId)) {
    cable.subscriptions.create(
      {
        channel: 'NotificationChannel',
        user_id: userId,
      },
      {
        connected: () => {},
        disconnected: () => {},
        received: (message) => {
          const messagesList = typeof message === 'string' ? JSON.parse(message) : message;

          store.dispatch(setUserUnReadNotifications(messagesList));
          messagesList.forEach((msg) => {
            if (
              msg.category === 'acknowledge_grave_relative_approval' ||
              msg.category === 'acknowledge_grave_owner_approval' ||
              msg.category === 'grave_invitation_acknowledgement'
            ) {
              const slug = msg.extra_info.slug;

              if (slug) {
                fetchGraveDetails(slug);
              }
            }
            if (msg.category === 'acknowledge_link_grave_approval') {
              const graveId = msg.extra_info.source_grave_id;
              if (graveId) {
                fetchLinedGraves(graveId);
              }
            }
          });
        },
      },
    );
  }
};

const isAlreadySubscribed = (cable, userId) => {
  const subscriptions = (cable.subscriptions && cable.subscriptions?.subscriptions) || [];

  if (subscriptions.length === 0) {
    return false;
  }

  return subscriptions.some((item) => {
    const parsedItem = JSON.parse(item.identifier);
    return parsedItem.channel === 'NotificationChannel' && parsedItem.user_id === userId;
  });
};

export default userNotification;
